import { DateField } from "./DateFields";
import { useLang } from "../lib/i18n";

export const monthStart = () => new Date().toISOString().slice(0, 8) + "01";
export const today = () => new Date().toISOString().slice(0, 10);

export function DateRange({ value, onChange, testid = "range" }) {
  const { t } = useLang();
  return (
    <div className="flex flex-wrap sm:flex-nowrap items-center gap-2" data-testid={testid}>
      <span className="text-sm font-semibold">{t("c.du")}</span>
      <DateField value={value.from} onChange={(v) => onChange({ ...value, from: v })} className="!w-40" testid={`${testid}-from`} />
      <span className="text-sm font-semibold">{t("c.au")}</span>
      <DateField value={value.to} onChange={(v) => onChange({ ...value, to: v })} className="!w-40" testid={`${testid}-to`} />
    </div>
  );
}

export const rangeParams = (r) => ({ date_from: r.from || undefined, date_to: r.to || undefined });
